import React, {Component} from 'react';
import {connect} from 'react-redux';
import { FJCloudAction, FJPaymentAction } from "../../../redux/action/FJRoot.action"
import FJViewConstant from "../../../constant/FJViewConstant";
import FJCloudFreeButton from "../view/cloud/FJCloudFreeButton";
import FJActionConstant from "../../../constant/FJActionConstant";
import FJCloudSyncButton from "../view/cloud/FJCloudSyncButton";
import FJCloudFulledButton from "../view/cloud/FJCloudFulledButton";
import FJCloudFailButton from "../view/cloud/FJCloudFailButton";

class FJMediaHeadCloud extends Component {


  /**
   * @description 点击升级按钮
   * @private
   */
  _upgrade = () => {
      this.props.upgrade();
  };

  /**
   * @description 跳转到工程页面
   * @private
   */
  _manage = () => {
      if (process.env.SERVE_ENV === 'release') {
          window.open('https://www.flexclip.com/editor/cloud');
      } else if (process.env.SERVE_ENV === "dev") {
          window.open('https://www.smartvideomaker.com/editor/cloud');
      }
  };

  render() {
    const {paymentLevel, cloudStatus, failed} = this.props;
    const {turnOnCloud, reUploadFilesOfFail} = this.props;

    if (paymentLevel === FJViewConstant.USER_PAYMENT_FREE) {
      return <FJCloudFreeButton onClick={turnOnCloud} />
    }

    switch (cloudStatus) {
      case FJActionConstant.CLOUD_STATUS_SYNC:
        return <FJCloudSyncButton />;
      case FJActionConstant.CLOUD_STATUS_FULL:
        return <FJCloudFulledButton paymentLevel={paymentLevel}
                                    onManage={this._manage}
                                    onUpgrade={this._upgrade} />
      case FJActionConstant.CLOUD_STATUS_FAIL:
        return <FJCloudFailButton failedCount={failed.length}
                                  onUpload={reUploadFilesOfFail} />
      default:
        return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    paymentLevel: state.payment.paymentLevel,
    cloudStatus: state.cloud.status,
    failed: state.cloud.failed
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      turnOnCloud: () => {
          dispatch(FJCloudAction.showCloudBenefitModalAction());
      },
      reUploadFilesOfFail: () => {
          dispatch(FJCloudAction.reUploadFilesOfFailAction());
          },
      upgrade: function (source) {
        dispatch(FJPaymentAction.upgradeLevelAction(source));
      },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(FJMediaHeadCloud);
